import { Theme } from '@mui/material/styles';

// ExpandedMenuItem styles
export const getExpandedMenuItemStyles = (backgroundColor: string) => ({
  backgroundColor,
  borderRadius: 1,
  padding: '12px 16px',
  marginLeft: '8px',
  marginRight: '8px',
  marginBottom: '4px',
  '&:hover': {
    backgroundColor: backgroundColor || 'action.hover', // Prevent grey hover if selected
  },
});

// Alert styles
export const getAlertStyles = () => ({
  marginLeft: '16px',
  marginRight: '16px',
  marginBottom: '8px',
});

// Refresh button styles
export const getRefreshButtonStyles = () => ({
  fontWeight: 500,
  fontSize: 'inherit',
  color: 'inherit',
});

// Back button styles
export const getBackButtonStyles = (theme: Theme) => ({
  color: '#666666',
  '&:focus-visible': {
    boxShadow: 'none',
    outline: `2px solid ${theme.palette.primary.dark}`,
  },
});

// Typography styles
export const getOptionTypographyStyles = () => ({
  fontSize: '16px',
});

export const getSubtextTypographyStyles = (theme: Theme) => ({
  fontSize: '14px',
  color: theme.palette.text.secondary,
});

// Grid container styles
export const getMainGridContainerStyles = () => ({
  justifyContent: 'space-between',
});

export const getGridItemWithMaxWidthStyles = (isDrawerSelect: boolean) => ({
  '&.MuiGrid-root': {
    maxWidth: isDrawerSelect ? '250px' : 'inherit',
  },
});

export const getRowGridContainerStyles = () => ({
  justifyContent: 'space-between',
});

// Chip styles
export const getChipStyles = () => ({
  fontWeight: '500',
});

// Icon styles
export const getArrowForwardIconStyles = () => ({
  width: '20px',
  height: '20px',
  color: '#6F6F73',
});

export const getCheckIconStyles = (theme: Theme) => ({
  color: theme.palette.primary.main,
});

// Box styles
export const getSingleSelectPopupStyles = (hasJurisdictionData?: boolean) => ({
  minHeight: hasJurisdictionData ? '700px' : '',
});

// Main text container styles (for the new layout)
export const getTextContainerStyles = (hasRightElements: boolean) => ({
  flex: 1,
  minWidth: 0,
  marginRight: hasRightElements ? '8px' : '0px',
});

export const getRightElementsContainerStyles = () => ({
  display: 'flex',
  alignItems: 'center', // Changed from flex-start to center for vertical centering
  gap: '4px',
  flexShrink: 0,
});

export const getWrappableTextStyles = () => ({
  fontSize: '16px',
  wordWrap: 'break-word' as const,
  lineHeight: 1.2,
});

export const customStartIconStyles = () => ({
  '& .MuiButton-startIcon': { marginRight: '-8px', marginLeft: '4px' },
});
